// extracted by mini-css-extract-plugin
module.exports = {"topright":"submenu_topright_2SC1B","titulo":"submenu_titulo_2Lzzf"};